import products from '../data/products.json'
export default function Home({ addToCart }) {
    return (
        <div className="container">
            <h1>Products</h1>
            <div className="grid">
                {products.map(p => (
                    <div key={p.id} className="card">
                        <img src={p.image} alt={p.name} />
                        <h3>{p.name}</h3>
                        <p className="price">${p.price.toFixed(2)}</p>
                        <button onClick={() => addToCart(p)}>Add to Cart</button>
                    </div>
                ))}
            </div>
        </div>
    )
}